import React from 'react';
import { Container, List } from '@pella/sash-framework';
import { CTA, Image } from '../../../components';
import PropTypes from 'prop-types';

const VisualNav = ({ placement, pageData }) => {
	const { heading, card } = pageData.offramps;
	return (
		<Container
			className={`${placement === 'top' ? 'mb-8 bg-gray-5 !p-5 md:!p-4 lg:!p-5' : 'max-md:bg-gray-5'}`}
			id={`visual-nav-${placement}`}
		>
			<div className={`${placement === 'bottom' ? 'bg-gray-5 py-4 md:!p-6' : ''}`}>
				{heading && <h2 className='text-subtitle mb-3 text-center font-bold md:mb-5 md:text-left'>{heading}</h2>}

				<List bullets='none' className='grid grid-cols-2 gap-2 md:flex md:gap-3 lg:gap-4'>
					{card.map((card, index) => {
						const { image, heading, ctas } = card;
						return (
							<li key={index} className='w-full flex flex-col'>
								<CTA
									data={ctas[0]}
									renderAs='link'
									className='grid w-full h-full justify-center border border-gray-10 bg-white p-3 no-underline hover:underline [&_span]:grid'
								>
									{image?.[0] && (
										<Image
											data={image[0]}
											className={`${placement === 'top' ? 'max-h-16 md:max-h-20 xl:max-h-[88px]' : 'max-h-20 xl:max-h-[120px]'} mb-3 justify-self-center`}
										/>
									)}
									<p className='text-center'>{heading}</p>
								</CTA>
							</li>
						);
					})}
				</List>
			</div>
		</Container>
	);
};

export default VisualNav;

VisualNav.propTypes = {
	placement: PropTypes.oneOf(['top', 'bottom']),
	pageData: PropTypes.object,
};
